import React, { useEffect, useState } from"react";
import axios from"axios";
import jsPDF from"jspdf";
import { useNavigate } from"react-router-dom";
import API_BASE_URL from"../../Config/config";

const styles = {
  container: {
    backgroundColor: "var(--bg-main)",
    minHeight: "100vh",
    padding: "4rem 2rem",
    fontFamily: "Segoe UI, sans-serif",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  backButton: {
    alignSelf: "flex-start",
    background: "#FFFFFF",
    color: "var(--primary-blue)",
    border: "1px solid var(--accent-gray)",
    padding: "12px 28px",
    fontWeight: "800",
    borderRadius: "16px",
    cursor: "pointer",
    textTransform: "uppercase",
    transition: "all 0.3s ease",
    marginBottom: "2rem",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
    fontSize: "14px",
    letterSpacing: "1px"
  },
  title: {
    fontSize: "48px",
    color: "var(--text-heading)",
    fontWeight: "900",
    textAlign: "center",
    marginBottom: "1rem",
    textTransform: "uppercase",
    letterSpacing: "-0.02em"
  },
  gridWrapper: {
    width: "100%",
    maxWidth: "1200px",
    padding: "1rem",
    boxSizing: "border-box",
  },
  grid: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "2.5rem",
  },
  card: {
    backgroundColor: "#E3F2FD", // Light Blue
    border: "1px solid var(--accent-gray)",
    borderRadius: "32px",
    width: "340px",
    padding: "2.5rem",
    color: "var(--text-body)",
    transition: "all 0.3s cubic-bezier(0.16, 1, 0.3, 1)",
    cursor: "default",
    boxShadow: "0 10px 30px rgba(31, 138, 203, 0.08)",
    position: "relative",
    overflow: "hidden"
  },
  cardHover: {
    boxShadow: "0 20px 50px rgba(31, 138, 203, 0.15)",
    transform: "translateY(-8px)",
    borderColor: "var(--primary-blue)",
    backgroundColor: "#FFFFFF",
  },
  heading: {
    fontSize: "24px",
    color: "var(--primary-blue)",
    fontWeight: "900",
    marginBottom: "1.5rem",
    textAlign: "left",
    lineHeight: "1.2"
  },
  detail: {
    fontSize: "15px",
    color: "var(--text-body)",
    marginBottom: "0.8rem",
    display: "flex",
    justifyContent: "space-between",
    fontWeight: "500"
  },
  button: {
    background: "var(--primary-blue)",
    color: "#fff",
    border: "none",
    padding: "16px",
    fontWeight: "800",
    borderRadius: "16px",
    cursor: "pointer",
    marginTop: "2rem",
    width: "100%",
    textTransform: "uppercase",
    boxShadow: "0 10px 20px rgba(43, 176, 230, 0.3)",
    transition: "all 0.3s ease",
    fontSize: "14px",
    letterSpacing: "1px"
  },
  activeCard: {
    background: "#E3F2FD", // Light Blue
    border: "2px solid var(--primary-blue)",
    borderRadius: "32px",
    padding: "2.5rem",
    marginBottom: "3rem",
    color: "var(--text-body)",
    boxShadow: "0 20px 50px rgba(31, 138, 203, 0.15)",
    position: "relative",
    overflow: "hidden"
  },
  badge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "0.35rem",
    padding: "0.4rem 1rem",
    borderRadius: "999px",
    backgroundColor: "var(--bg-soft)",
    border: "1px solid var(--primary-blue)",
    color: "var(--primary-blue)",
    fontSize: "11px",
    fontWeight: "900",
    letterSpacing: "0.1em",
    textTransform: "uppercase",
  },
  featurePill: {
    padding: "0.5rem 1rem",
    borderRadius: "999px",
    border: "1px solid var(--accent-gray)",
    color: "var(--text-body)",
    fontSize: "12px",
    background: "var(--bg-main)",
    fontWeight: "700"
  },
  ctaButton: {
    background: "var(--primary-blue)",
    color: "#fff",
    border: "none",
    padding: "1rem 2rem",
    fontWeight: "900",
    borderRadius: "999px",
    cursor: "pointer",
    boxShadow: "0 10px 25px rgba(43, 176, 230, 0.3)",
    transition: "all 0.3s ease",
    textTransform: "uppercase",
    letterSpacing: "1px"
  },
  purchaseAddonText: {
    color: "#000000",
    fontWeight: "900",
    textTransform: "uppercase",
    fontSize: "14px",
    letterSpacing: "1px"
  }
};

const ACTIVE_PLAN_FEATURES = [
"Mock Interviews & AI Feedback",
"LLM Assistant + Voice Mentor",
"All 5 Dashboards & Launchpads",
"Compiler + Resume & Report tools",
"Premium Support & Certifications",
];

const MockInterviewMyPaymentHistory = () => {
 const [payments, setPayments] = useState([]);
 const [hoverIndex, setHoverIndex] = useState(null);
 const [loading, setLoading] = useState(true);
 const [activePlan, setActivePlan] = useState(null);
 const [activePlanLoading, setActivePlanLoading] = useState(true);
 const navigate = useNavigate();

 // Helper to get correct amount from payment object
 const getPaymentAmount = (p) => Number(p.payable_amount || p.amount || 0);
 const getBasePrice = (p) => Number(p.base_price || p.amount || 0);
 const getDiscountPercentage = (p) => Number(p.discount_percentage || 0);

 // Get user object and extract user_code (which is stored as user_id in mock_interview_payments)
 const user = JSON.parse(localStorage.getItem("user"));
 // Try to get user_code first, then fallback to other IDs
 const userId = user?.user_code || user?.user_id || user?.id || user?.userId || localStorage.getItem('user_id') || null;

 useEffect(() => {
 if (!userId) {
 setLoading(false);
 return;
 }

 const fetchPayments = async () => {
 try {
 setLoading(true);
 console.log(`[Payment History] Fetching payments for user: ${userId}`);
 const { data } = await axios.get(
 `${API_BASE_URL}/api/skillgenie-premium/user/${userId}`
 );
 console.log(`[Payment History] Received ${data.payments?.length || 0} payments`);
 setPayments(data.payments || []);
 } catch (err) {
 console.error("Failed to fetch payment history", err);
 console.error("Error details:", err.response?.data || err.message);
 } finally {
 setLoading(false);
 }
 };

 fetchPayments();
 }, [userId]);

useEffect(() => {
 if (!userId) {
 setActivePlanLoading(false);
 return;
 }
 let cancelled = false;
 const fetchActivePlan = async () => {
 try {
 setActivePlanLoading(true);
 console.log(`[Payment History] Fetching active plan for user: ${userId}`);
 const { data } = await axios.get(
 `${API_BASE_URL}/api/skillgenie-premium/active-plan/${userId}`
 );
 if (cancelled) return;
 console.log(`[Payment History] Active plan response:`, data);
 if (data?.ok && data.hasActiveSubscription && data.plan) {
 console.log(`[Payment History] Setting active plan:`, data.plan);
 setActivePlan(data.plan);
 } else {
 console.log(`[Payment History] No active subscription found from API. Response:`, data);
 // Fallback: Try to find active plan from payments list
 setActivePlan(null);
 }
 } catch (err) {
 if (!cancelled) {
 console.error("[Payment History] Failed to fetch active plan", err);
 console.error("[Payment History] Error response:", err.response?.data);
 setActivePlan(null);
 }
 } finally {
 if (!cancelled) setActivePlanLoading(false);
 }
 };
 fetchActivePlan();
 return () => {
 cancelled = true;
 };
}, [userId]);

 // Fallback: Derive active plan from payments list if active-plan endpoint didn't find one
 useEffect(() => {
 // Only run fallback if active plan is null but we have payments
 if (!activePlan && !activePlanLoading && payments && payments.length > 0) {
 console.log(`[Payment History] Checking payments list for active subscription as fallback...`);
 const now = new Date();
 
 // Find the most recent active payment
 const activePayments = payments
 .filter(p => {
 if (p.status !== 'success' || p.payment_method === 'trial') return false;
 
 // Check if payment is active
 if (p.end_date) {
 const endDate = new Date(p.end_date);
 return endDate > now;
 }
 
 // If no end_date, check if created recently (within last 2 years)
 if (p.created_at) {
 const createdAt = new Date(p.created_at);
 const twoYearsAgo = new Date();
 twoYearsAgo.setFullYear(twoYearsAgo.getFullYear() - 2);
 return createdAt > twoYearsAgo;
 }
 
 return false;
 })
 .sort((a, b) => {
 // Sort by end_date descending, then created_at descending
 const aEnd = a.end_date ? new Date(a.end_date) : null;
 const bEnd = b.end_date ? new Date(b.end_date) : null;
 if (aEnd && bEnd) return bEnd - aEnd;
 if (aEnd) return -1;
 if (bEnd) return 1;
 return new Date(b.created_at) - new Date(a.created_at);
 });
 
 if (activePayments.length > 0) {
 const activePayment = activePayments[0];
 console.log(`[Payment History] Found active plan from payments list:`, activePayment);
 
 // Create plan object from payment
 const endDate = activePayment.end_date ? new Date(activePayment.end_date) : null;
 const daysRemaining = endDate ? Math.ceil((endDate - now) / (1000 * 60 * 60 * 24)) : null;
 
 let planLabel = 'Premium Subscription';
 let durationLabel = 'Full access';
 let badge = 'Active';
 
 // Check for LLM trial
 if (activePayment.payment_method === 'llm_trial' || 
 activePayment.plan_name === 'llm_trial_7days' ||
 (activePayment.amount === 0 && activePayment.payment_method !== 'razorpay')) {
 planLabel = '7 Days Free Trial';
 durationLabel = '7 days LLM access';
 badge = 'Free Trial';
 } else if (activePayment.amount === 2999) {
 planLabel = 'Basic (Monthly)';
 durationLabel = '30 days access';
 badge = 'Starter';
 } else if (activePayment.amount === 7999) {
 planLabel = 'Standard (3 Months)';
 durationLabel = '90 days access';
 badge = 'Most Popular';
 } else if (activePayment.amount === 14999) {
 planLabel = 'Premium (6 Months)';
 durationLabel = '180 days access';
 badge = 'Best Value';
 }
 
 setActivePlan({
 id: activePayment.id,
 label: planLabel,
 badge: badge,
 duration_label: durationLabel,
 amount: activePayment.amount,
 plan_name: activePayment.plan_name || planLabel,
 start_date: activePayment.start_date || activePayment.created_at,
 end_date: activePayment.end_date,
 daysRemaining,
 payment_method: activePayment.payment_method,
 transaction_id: activePayment.transaction_id,
 features: ACTIVE_PLAN_FEATURES,
 status: activePayment.status
 });
 }
 }
 }, [payments, activePlan, activePlanLoading]);

  const handleDownloadReceipt = (payment) => {
    if (!payment) return;
    const doc = new jsPDF();

    // Company Information
    const companyName = "EvolveX Innovations";
    const gstNumber = "37BABPP44341Z4";
    const brandName = "The Skill Genie";

    // Add Logo (using logo192.png or just text if logo loading fails)
    try {
      // Add Brand Logo (if exists)
      const logoImg = new Image();
      logoImg.src = "/logo192.png";
      doc.addImage(logoImg, "PNG", 150, 45, 40, 40);
    } catch (e) {
      console.warn("Logo could not be added to PDF", e);
    }

    try {
      // Brand Name
    doc.setFontSize(24);
    doc.setTextColor(31, 138, 203); // var(--primary-blue)
    doc.setFont("helvetica", "bold");
    doc.text(brandName, 20, 25);
    
    doc.setFontSize(10);
    doc.setTextColor(100, 116, 139);
    doc.setFont("helvetica", "normal");
    doc.text("Powered by " + companyName, 20, 32);

      doc.setFontSize(22);
      doc.setTextColor(31, 138, 203);
      doc.setFont("helvetica", "bold");
      doc.text("OFFICIAL RECEIPT", 190, 25, { align: "right" });
    } catch (e) {
      doc.setFontSize(22);
      doc.setTextColor(31, 138, 203);
      doc.text("OFFICIAL RECEIPT", 105, 30, { align: "center" });
    }

    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "bold");
    doc.text("Billed By:", 20, 50);
    doc.setFont("helvetica", "normal");
    doc.text(companyName, 20, 57);
    doc.text("GSTIN: " + gstNumber, 20, 64);

    doc.setDrawColor(224, 242, 254);
    doc.line(20, 70, 190, 70);

    let yPos = 85;
   doc.setFontSize(12);
  
   // Determine plan name
   let planName = payment.name || payment.planName || payment.plan_name || "Premium Subscription";
   if (payment.payment_method === 'llm_trial' || 
       payment.plan_name === 'llm_trial_7days' ||
       (payment.amount === 0 && payment.payment_method !== 'razorpay' && payment.payment_method !== 'trial')) {
     planName = '7 Days Free Trial';
   }

   const details = [
     ["Plan Name:", planName],
     ["Original Price:", `INR ${(getBasePrice(payment) || 0).toLocaleString('en-IN')}`],
     ["Scholarship %:", `${getDiscountPercentage(payment) || 0}%`],
     ["Discount Amount:", `INR ${((getBasePrice(payment) || 0) - (getPaymentAmount(payment) || 0)).toLocaleString('en-IN')}`],
     ["Final Paid Amount:", `INR ${(getPaymentAmount(payment) || 0).toLocaleString('en-IN')}`],
     ["", ""],
     ["Payment ID:", payment.razorpay_payment_id || "N/A"],
     ["Order ID:", payment.razorpay_order_id || "N/A"],
     ["Purchase Date:", payment.created_at ? new Date(payment.created_at).toLocaleDateString('en-IN') : "N/A"],
     ["Start Date:", payment.start_date ? new Date(payment.start_date).toLocaleDateString('en-IN') : "N/A"],
     ["End Date:", payment.end_date ? new Date(payment.end_date).toLocaleDateString('en-IN') : "N/A"],
     ["Status:", (payment.status || "success").toUpperCase()]
   ];

   details.forEach(([label, value]) => {
     if (label === "") {
       yPos += 5;
     } else {
       doc.setFont("helvetica", "bold");
       doc.text(label, 20, yPos);
       doc.setFont("helvetica", "normal");
       doc.text(String(value), 80, yPos);
       yPos += 10;
     }
   });

   doc.setDrawColor(224, 242, 254);
   doc.line(20, yPos + 10, 190, yPos + 10);
  
   doc.setFontSize(10);
   doc.setTextColor(148, 163, 184);
   doc.text("This is a computer-generated receipt and does not require a physical signature.", 105, yPos + 25, { align: "center" });
   doc.text("Thank you for choosing SkillGenie Premium!", 105, yPos + 32, { align: "center" });

   const fileName = payment.razorpay_payment_id 
     ? `Receipt_${payment.razorpay_payment_id}.pdf`
     : `Receipt_${payment.id || Date.now()}.pdf`;
   doc.save(fileName);
 };

 const formatDate = (dateValue) => {
 if (!dateValue) return"N/A";
 return new Date(dateValue).toLocaleDateString("en-IN", {
 year:"numeric",
 month:"long",
 day:"numeric",
 });
 };

 const renderActivePlanSection = () => {
 if (activePlanLoading) {
 return (
 <div style={styles.activeCard}>
 <p style={{ color:"#22D3EE", fontSize:"14px", fontWeight:"bold", marginBottom:"0.5rem" }}>
 Verifying your active plan...
 </p>
 <div style={{ width:"100%", height:"2px", background:"rgba(255,255,255,0.05)", borderRadius:"10px", overflow:"hidden" }}>
 <div className="animate-marquee" style={{ width:"30%", height:"100%", background:"var(--primary-blue, #4F46E5)" }}></div>
 </div>
 </div>
 );
 }

 if (!activePlan) {
 return (
 <div style={styles.activeCard}>
 <div style={{ display:"flex", justifyContent:"space-between", flexWrap:"wrap", gap:"1.5rem", alignItems:"center" }}>
 <div>
 <div style={styles.badge}>No Active Plan</div>
 <h3 style={{ marginTop:"1rem", marginBottom:"0.5rem", fontSize:"2rem", fontWeight:"900", trackingTighter:"1px" }}>
 Unlock Premium Mastery
 </h3>
 <p style={{ color:"#94A3B8", margin: 0, fontSize:"1.1rem" }}>
 Gain unlimited access to AI mentors, advanced challenges, and industry interview suites.
 </p>
 </div>
 <button
 className="btn-primary-gradient"
 style={{ ...styles.ctaButton, alignSelf:"center", padding:"1.2rem 2.5rem", fontSize:"1.1rem" }}
 onClick={() => navigate("/subscription-plans")}
 >
 Browse Plans ->
 </button>
 </div>
 </div>
 );
 }

 const features = activePlan.features?.length ? activePlan.features : ACTIVE_PLAN_FEATURES;

 return (
 <div style={styles.activeCard}>
 <div style={{ display:"flex", justifyContent:"space-between", flexWrap:"wrap", gap:"1.5rem" }}>
 <div>
 <div style={styles.badge}>{activePlan.badge ||"Premium"}</div>
 <h3 style={{ marginTop:"1rem", marginBottom:"0.5rem", fontSize:"2.2rem", fontWeight:"900", letterSpacing:"-1px" }}>
 {activePlan.label ||"Premium Subscription"}
 </h3>
 <div style={{ display:"flex", alignItems:"center", gap:"12px" }}>
 <span style={{ color:"var(--primary-blue, #4F46E5)", fontSize:"1.5rem", fontWeight:"900" }}>
 ₹{activePlan.amount?.toLocaleString("en-IN")}
 </span>
 <span style={{ color:"#64748B", fontWeight:"bold" }}>•</span>
 <span style={{ color:"#22D3EE", fontWeight:"bold", textTransform:"uppercase", fontSize:"14px" }}>
 {activePlan.duration_label ||"Full access"}
 </span>
 </div>
 </div>
 <div style={{ textAlign:"right" }}>
 <p style={{ margin: 0, color:"#64748B", fontSize:"12px", fontWeight:"900", textTransform:"uppercase", letterSpacing:"1px" }}>Access Ends On</p>
 <p style={{ margin: "4px 0", fontSize: "1.5rem", fontWeight: "900", color: "var(--text-heading)" }}>{formatDate(activePlan.end_date)}</p>
 {typeof activePlan.daysRemaining ==="number" && (
 <div style={{ display:"flex", alignItems:"center", gap:"8px", justifyContent:"flex-end" }}>
 <div style={{ width:"80px", height:"4px", background:"rgba(255,255,255,0.05)", borderRadius:"10px", overflow:"hidden" }}>
 <div style={{ width: `${Math.min((activePlan.daysRemaining / 30) * 100, 100)}%`, height:"100%", background:"#4ade80" }}></div>
 </div>
 <p style={{ margin: 0, color:"#4ade80", fontWeight:"900", fontSize:"12px" }}>
 {activePlan.daysRemaining} DAYS LEFT
 </p>
 </div>
 )}
 </div>
 </div>

 <div style={{ marginTop:"2rem", borderTop:"1px solid rgba(255,255,255,0.05)", paddingTop:"1.5rem" }}>
 <p style={{ margin:"0 0 1rem", color:"#64748B", fontSize:"11px", fontWeight:"900", textTransform:"uppercase", letterSpacing:"1.5px" }}>Included Premium Features:</p>
 <div style={{ display:"flex", flexWrap:"wrap", gap:"0.75rem" }}>
 {features.slice(0, 6).map((feature) => (
 <span key={feature} style={styles.featurePill}>
 ✓ {feature}
 </span>
 ))}
 </div>
 </div>

 <div style={{ marginTop:"2.5rem", display:"flex", gap:"1rem", flexWrap:"wrap" }}>
 <button
 style={styles.ctaButton}
 onClick={() => navigate("/subscription-plans")}
 >
 Manage Subscription
 </button>
 <button
 style={{
 ...styles.ctaButton,
 background:"rgba(255,255,255,0.05)",
 border:"1px solid rgba(255,255,255,0.1)",
 boxShadow:"none"
 }}
 onClick={() => navigate("/subscription-plans")}
 >
 <span style={styles.purchaseAddonText}>Purchase Add-ons</span>
 </button>
 </div>
 </div>
 );
 };

 return (
 <div style={styles.container}>
 <button style={styles.backButton} onClick={() => navigate("/dashboard")}>
 ← Back
 </button>

 <h2 style={styles.title}>My Subscriptions & Payment History</h2>
   <p style={{ color: "var(--text-body)", fontSize: "14px", textAlign: "center", marginBottom: "1rem" }}>
 View all your premium subscription payments and access details
 </p>

 {loading ? (
 <div style={{ color:"#ccc", fontSize:"16px", textAlign:"center" }}>
 Loading payment history...
 </div>
 ) : (
 <div style={styles.gridWrapper}>
 {renderActivePlanSection()}
      {/* Summary Section */}
      {payments.length > 0 && (
        <div style={{
          backgroundColor: "var(--bg-section)",
          border: "1px solid var(--accent-gray)",
          borderRadius: "24px",
          padding: "2rem",
          marginBottom: "3rem",
          color: "var(--text-body)",
          maxWidth: "1000px",
          width: "100%",
          boxShadow: "0 10px 30px rgba(31, 138, 203, 0.08)"
        }}>
          <h3 style={{ ...styles.heading, textAlign: "center", marginBottom: "2rem", textTransform: "uppercase", letterSpacing: "1px", color: "var(--text-heading)" }}>Subscription Summary</h3>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "2rem" }}>
            <div style={{ textAlign: "center", padding: "1.5rem", background: "#FFFFFF", borderRadius: "16px", border: "1px solid var(--accent-gray)" }}>
              <p style={{ fontSize: "12px", fontWeight: "900", color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "1px", marginBottom: "0.5rem" }}>Total Payments</p>
              <p style={{ fontSize: "32px", fontWeight: "900", color: "var(--text-heading)", margin: 0 }}>
                {payments.length}
              </p>
            </div>
            <div style={{ textAlign: "center", padding: "1.5rem", background: "#FFFFFF", borderRadius: "16px", border: "1px solid var(--accent-gray)" }}>
              <p style={{ fontSize: "12px", fontWeight: "900", color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "1px", marginBottom: "0.5rem" }}>Total Amount</p>
              <p style={{ fontSize: "32px", fontWeight: "900", color: "var(--primary-blue)", margin: 0 }}>
                ₹{payments.reduce((sum, p) => sum + getPaymentAmount(p), 0).toLocaleString('en-IN')}
              </p>
            </div>
            <div style={{ textAlign: "center", padding: "1.5rem", background: "#FFFFFF", borderRadius: "16px", border: "1px solid var(--accent-gray)" }}>
              <p style={{ fontSize: "12px", fontWeight: "900", color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "1px", marginBottom: "0.5rem" }}>Active Plans</p>
              <p style={{ fontSize: "32px", fontWeight: "900", color: "#10b981", margin: 0 }}>
                {payments.filter(p => {
                  if (!p.end_date) return false;
                  return new Date(p.end_date) > new Date();
                }).length}
              </p>
            </div>
          </div>
        </div>
      )}

 <div style={styles.grid}>
 {userId ? (
 payments.length === 0 ? (
 <p style={{ color:"#ccc", fontSize:"16px" }}>
 No payments found. Make a payment to see your subscription history here.
 </p>
 ) : (
 payments.map((payment, index) => {
 const cardStyle =
 hoverIndex === index
 ? { ...styles.card, ...styles.cardHover }
 : styles.card;

 // Calculate subscription duration and remaining days
 const startDate = payment.start_date ? new Date(payment.start_date) : new Date(payment.created_at);
 const endDate = payment.end_date ? new Date(payment.end_date) : null;
 const now = new Date();
 const isActive = endDate && endDate > now;
 const daysRemaining = endDate ? Math.ceil((endDate - now) / (1000 * 60 * 60 * 24)) : null;
 const isExpired = endDate && endDate <= now;
 
 // Determine plan duration based on amount
 let planDuration ="N/A";
 if (payment.amount === 2999) planDuration ="30 days (1 month)";
 else if (payment.amount === 7999) planDuration ="90 days (3 months)";
 else if (payment.amount === 14999) planDuration ="180 days (6 months)";
 else if (payment.amount === 299 || payment.amount === 399) planDuration ="Legacy Plan";
 else planDuration ="Custom Plan";

 return (
 <div
 key={payment.id || index}
 style={cardStyle}
 onMouseEnter={() => setHoverIndex(index)}
 onMouseLeave={() => setHoverIndex(null)}
 >
 <div style={{ position:"absolute", top: 0, left: 0, width:"100%", h:"4px", background: isActive ?"linear-gradient(90deg, #22D3EE, var(--primary-blue, #4F46E5))" :"transparent" }}></div>
 <h3 style={styles.heading}>
 {(() => {
 if (payment.payment_method === 'llm_trial' || 
 payment.plan_name === 'llm_trial_7days' ||
 (payment.amount === 0 && payment.payment_method !== 'razorpay' && payment.payment_method !== 'trial')) {
 return '✨ 7 Days Trial';
 }
 return payment.name || payment.planName || payment.plan_name ||"Premium Subscription";
 })()}
 </h3>
 
 <div style={{ marginBottom:"1.5rem", borderBottom:"1px solid rgba(255, 255, 255, 0.05)", paddingBottom:"1rem" }}>
 <div style={styles.detail}>
 <span>Amount Paid</span>
 <span style={{ color:"#1f8acb", fontWeight:"bold" }}>₹{getPaymentAmount(payment).toLocaleString('en-IN')}</span>
 </div>
 {getDiscountPercentage(payment) > 0 && (
   <>
     <div style={styles.detail}>
       <span>Original Price</span>
       <span style={{ textDecoration: 'line-through', color: '#94a3b8' }}>₹{getBasePrice(payment).toLocaleString('en-IN')}</span>
     </div>
     <div style={styles.detail}>
       <span>Scholarship</span>
       <span style={{ color: '#10b981', fontWeight: 'bold' }}>{getDiscountPercentage(payment)}% OFF</span>
     </div>
   </>
 )}
 <div style={styles.detail}>
 <span>Access Period</span>
 <span style={{ color:"var(--text-body)" }}>{planDuration}</span>
 </div>
 <div style={styles.detail}>
 <span>Current Status</span>
 <span style={{ 
 color: payment.status === 'success' 
 ? (isActive ? '#4ade80' : isExpired ? '#f87171' : '#94a3b8')
 : '#f87171',
 fontWeight:"bold"
 }}>
 {payment.status === 'success' 
 ? (isActive ? 'ACTIVE' : isExpired ? 'EXPIRED' : 'COMPLETED')
 : payment.status.toUpperCase()}
 </span>
 </div>
 </div>

 <div style={{ spaceY:"0.5rem" }}>
 {startDate && (
 <div style={{ ...styles.detail, fontSize:"12px", marginBottom:"4px" }}>
 <span>Start Date</span>
 <span>{startDate.toLocaleDateString('en-IN')}</span>
 </div>
 )}
 {endDate && (
 <div style={{ ...styles.detail, fontSize:"12px", marginBottom:"4px" }}>
 <span>End Date</span>
 <span>{endDate.toLocaleDateString('en-IN')}</span>
 </div>
 )}
 {isActive && daysRemaining !== null && (
 <div style={{ ...styles.detail, fontSize:"12px", color: '#4ade80', fontWeight:"bold", marginTop:"8px" }}>
 <span>Time Left</span>
 <span>{daysRemaining} DAYS</span>
 </div>
 )}
 </div>

 {payment.razorpay_payment_id && (
 <p style={{ fontSize: '10px', color: '#64748B', marginTop:"1rem", textTransform:"uppercase", letterSpacing:"0.5px" }}>
 ID: {payment.razorpay_payment_id.substring(0, 20)}...
 </p>
 )}

 <button
 style={styles.button}
 onClick={() => handleDownloadReceipt(payment)}
 >
 Download Receipt
 </button>
 </div>
 );
 })
 )
 ) : (
 <p style={{ color:"#ccc", fontSize:"16px" }}>
 Please log in to view your payment history.
 </p>
 )}
 </div>
 </div>
 )}
 </div>
 );
};

export default MockInterviewMyPaymentHistory;




